import { render, staticRenderFns } from "./BookingVisitInfo.vue?vue&type=template&id=2b920538&scoped=true"
import script from "./BookingVisitInfo.vue?vue&type=script&lang=ts"
export * from "./BookingVisitInfo.vue?vue&type=script&lang=ts"
import style0 from "./BookingVisitInfo.vue?vue&type=style&index=0&id=2b920538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b920538",
  null
  
)

export default component.exports